export interface User {
  id: string;
  email: string;
  name?: string;
  display_name?: string; // auth.users의 user_metadata에서 사용
  team?: string;
  position?: string;
  role?: string;
  is_active?: boolean;
  password_changed_from_initial: boolean;
}


export interface MeetingBooking {
  id: string;
  title: string;
  start: Date;
  end: Date;
  backgroundColor?: string;
  borderColor?: string;
  textColor?: string;
  description?: string;
  roomName?: string;
  attendee_uids?: string[]; // attendees에서 attendee_uids로 변경
  extendedProps?: {
    roomName?: string;
    description?: string;
    attendee_uids?: string[]; // attendees에서 attendee_uids로 변경
    userId?: string;
    userName?: string;
    userEmail?: string;
    is_reminder_enabled?: boolean;
    reminder_minutes: number; // 추가: 리마인더 알림 시간 (5, 10, 15, 20, 30분)
    parent_booking_id?: string;
    recurrence_type?: string;
    recurrence_end_date?: Date | null;
  };
}


export interface MeetingRoom {
  id: string;
  name: string;
  capacity: number;
  location: string;
  equipment?: string;
  image_url: string;
  description?: string;
  color: string;
  /**
   * 이 날짜까지 회의 예약 가능 ('YYYY-MM-DD', 해당 날짜 포함).
   * 비어 있으면 제한이 없는 회의실이다. 판정은 utils/roomAvailability 참고.
   */
  available_until?: string | null;
}

export interface Booking {
  id: string;
  roomId: string;
  roomName: string;
  title: string;
  description?: string;
  startTime: Date;
  endTime: Date;
  userId: string;
  // userEmail 필드 제거 - 데이터베이스에 없음
  attendee_uids?: string[]; // 참석자 이메일에서 UUID 배열로 변경
  // status 필드 제거 - 데이터베이스에 없음
  // createdAt 필드는 데이터베이스에서 자동 생성됨
  color: string;
  is_reminder_enabled: boolean;
  reminder_minutes: number; // 추가: 리마인더 알림 시간 (5, 10, 15, 20, 30분)
  parent_booking_id?: string;
  recurrence_type?: string;
  recurrence_end_date?: Date | null;
}

export interface CalendarEvent {
  id: string;
  title: string;
  start: Date;
  end: Date;
  resourceId?: string;
  backgroundColor?: string;
  borderColor?: string;
  extendedProps?: {
    booking: Booking;
  };
}

// export interface User {
//   id: string;
//   email: string;
//   password?: string; // Supabase에서는 필요 없을 수 있으므로 선택적으로 변경
//   name: string;
//   role?: string; // 사용자 역할 (예: 'user', 'admin' 등)
// }

export type BookingStatus = 'upcoming' | 'ongoing' | 'completed' | 'cancelled';

export type CalendarView = 'month' | 'week' | 'day' | 'list';

// 피드백 시스템 관련 타입 정의
export interface Feedback {
  id: string;
  sender_id: string;          // 보내는 사람 (User ID)
  sender_name: string;        // 보내는 사람 이름
  sender_email: string;       // 보내는 사람 이메일
  category: string; // 카테고리
  subject: string;            // 제목
  content: string;            // 내용
  attachments?: string[];     // 첨부파일 URL 배열
  status: FeedbackStatus;     // 처리 상태
  assigned_to?: string;       // 담당자 이메일
  created_at: Date;
  updated_at: Date;
  response?: string;          // 답변 내용
  responded_at?: Date;        // 답변 일시
}


export enum FeedbackStatus {
  PENDING = 'pending',         // 대기중
  IN_PROGRESS = 'in_progress', // 처리중
  RESOLVED = 'resolved',       // 해결됨
  CLOSED = 'closed'           // 종료됨
}

// 피드백 생성 시 사용할 인터페이스
export interface CreateFeedbackRequest {
  category: string;
  subject: string;
  content: string;
  attachments?: File[];  // 업로드할 파일들
}

// 카테고리별 담당자 정보
export interface CategoryAssignee {
  category: string;
  assignee_email: string;
  assignee_name: string;
  description: string;            // 담당 업무 설명
}

// 한국 공휴일 정보
export interface KoreanHoliday {
  title: string;
  start: string;
  end: string;
  allDay: boolean;
}

// 반복 캘린더 이벤트 정보 (공휴일, 창립기념일 등)
export interface RecurringCalendarEvent {
  title: string;
  start: string;
  end: string;
  allDay: boolean;
  isRecurring: boolean;
  recurrenceRule: string;
}

// 캘린더 이벤트 API 응답
export interface CalendarEventApiResponse {
  success: boolean;
  data: RecurringCalendarEvent[];
  timestamp: string;
  summary: {
    totalEvents: number;
    hasRecurring: boolean;
    dateRange: {
      first: string;
      last: string;
    };
  };
}
